import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, useIonModal, IonButtons, IonButton, IonFabList, IonItemOption, IonItemOptions, IonItemSliding, useIonAlert, IonLoading } from '@ionic/react';
import { useState, useEffect } from 'react';
import { addOutline, cameraOutline, chevronBack, documentOutline, documentTextOutline, pencilOutline, peopleOutline, shareOutline } from 'ionicons/icons';
import { useHistory } from 'react-router';
import { addUserListener, getUser } from '../firebase/users';
import UserEditor from './UserEditor';
import { registerClientCommentsSnapshotListener } from '../firebase/clientComments';
import dateFormat from 'dateformat';
import { getDocumentTemplates } from '../firebase/documentTemplates';
import { getDateFromPath, getFileList, getUserIdFromPath, removeFile, uploadFile } from '../firebase/firebaseStorage';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { getCurrentUser, getCurrentUserUID, isValidId } from '../firebase/firebase';
import IonPhotoViewer from '@codesyntax/ionic-react-photo-viewer';
import { sharePicture } from './Picture';
import { getPermissionsDisplay } from './Permissions';

const ClientCommentsList: React.FC<{ clientId: string }> = (props) => {
  const history = useHistory();
  const [presentAlert] = useIonAlert();
  const [comments, setComments] = useState<any>([]);
  const [pictures, setPictures] = useState<any>([]);
  const [busy, setBusy] = useState<boolean>(false);
  useEffect(() => {
    registerClientCommentsSnapshotListener(props.clientId, ((commentList: []) => {
      setComments(commentList);
    }));
    loadFiles(false);
  }, []);

  function loadFiles(reload = false) {
    setBusy(true)
    if (isValidId(props.clientId)) {
      getFileList(props.clientId, null, reload).then((list) => {
        if (list !== null) {          
          setPictures(list);
          setBusy(false);
        }
        
      });
    }
  }



  // const [presentEditor, dismissEditor] = useIonModal(UserEditor, {
  //   user: user,
  //   onDismiss: () => dismissEditor()
  // });

  // function openEditor(e: any = null) {
  //   if (e !== null) {
  //     setUser(e);
  //   } else {
  //     setUser({})
  //   }

  //   presentEditor();
  // }

  async function takePhoto() {
    //setBusy(true);
    Camera.getPhoto({
      resultType: CameraResultType.Base64,
      source: CameraSource.Prompt,
      quality: 70,
      allowEditing: false,
      promptLabelHeader: 'Wybierz...',
      promptLabelCancel: 'anuluj',
      promptLabelPhoto: 'galeria',
      promptLabelPicture: 'aparat'
    }).then(async (p) => {
      await uploadFile(props.clientId, null, p);
      loadFiles(true);
    }).catch((e) => {
      console.error(e)
      //setBusy(false);
    })
    //setBusy(false)
  }

  function getDescription(c: any) {
    var r = "";
    if (c.created !== undefined && c.created !== null) {
      r += dateFormat(c.created.toDate(), "yyyy-mm-dd HH:MM") + " - ";
    }
    if (c.topic !== undefined && c.topic !== null) {
      r += c.topic;
    }
    return r;
  }

  const templates = getDocumentTemplates(false, 1);



  function isEditable(item: any) {
    const currenUser = getCurrentUser();
    if ((currenUser.role === "manager")) {
      return true;
    }
    if ((currenUser.id === getUserIdFromPath(item.path))) {
      return true;
    }
    if (item.permission === "write") {
      return true;
    }
    return false;
  }

  function isAccess(d : any){
    if (getCurrentUser().role === "manager" || getCurrentUser().id === d.userId || (d.hasOwnProperty("permissions") && d.permissions.hasOwnProperty(getCurrentUser().id) && d.permissions[getCurrentUser().id] !== 'none')) {
      return true;
    }else{
      return false;
    }
  }

  async function cropPicture(item: any) {
    history.push("/app/imageviewer/" + item.path.replaceAll("/", "-"));
  }

  async function permissions(item: any) {
    history.push("/app/imagepermissions/" + item.path.replaceAll("/", "-"));
  }




  function removePicture(path: string) {
    presentAlert({
      header: 'Usuwanie!',
      buttons: [
        {
          text: 'Anuluj',
          role: 'cancel'
        },
        {
          text: 'Usuń',
          role: 'confirm',
        },
      ],
      onDidDismiss: async (e: CustomEvent) => {
        if (e.detail.role === 'confirm') {
          //setBusy(true);
          if (await removeFile(path)) {
            loadFiles(true);
          } else {
            //setBusy(false)
          }
        }
      },
    })
  }

  // function getPermissionsList(p: any) {
  //   //console.log("ClientCommentsList-getPermissionsList", picture)
  //   var r = "";
  //   if (p.userId !== undefined) {
  //     r += getUser(p.userId)?.initials + ": ";
  //   }else{
  //     r += getUser(getUserIdFromPath(p.path))?.initials+": ";
  //   }
  //   for (var key in p.permissions) {
  //     if (p.permissions[key] !== "none") {
  //       r += getUser(key).initials;
  //       if (p.permissions[key] === "write") {
  //         r += "*";
  //       }
  //       r += " ";
  //     }
  //   }
  //   return r;
  // }


  return (


    <div>
      <div>
        {comments.map((c: any) => (

          <IonItem  routerLink={isAccess(c)?("/app/clients/" + props.clientId + "/comment/" + c.id) : ""} disabled={!isAccess(c)} onClick={(e) => { }} key={c.id} >
            <div style={{ minWidth: "20px", color: "lightgray", fontSize: "10px", position: "absolute", top: "2px", left: "26px" }}>{getPermissionsDisplay(c)}</div>
            <IonLabel><IonIcon icon={documentOutline} style={{ marginRight: "10px" }} />{getDescription(c)}</IonLabel>
          </IonItem>
        ))}
        {pictures.map((p: any) => (

          <IonItemSliding key={p.path}>
            {isEditable(p) ?
              <IonItemOptions hidden={false} side="start">
                <IonItemOption onClick={(e) => { sharePicture(p) }}><IonIcon icon={shareOutline} /></IonItemOption>
                <IonItemOption onClick={(e) => { cropPicture(p) }} color="secondary" ><IonIcon icon={pencilOutline} /></IonItemOption>
                <IonItemOption onClick={(e) => { permissions(p) }}  ><IonIcon icon={peopleOutline} /></IonItemOption>
              </IonItemOptions> : ""}
            {isEditable(p) ?
              <IonItemOptions hidden={false} side="end">
                <IonItemOption color="danger" onClick={(e) => { removePicture(p.path) }}>{"usuń"}</IonItemOption>
              </IonItemOptions> : ""}

            <IonItem disabled={!isEditable(p)}>
              <div style={{ minWidth: "20px", color: "lightgray", fontSize: "10px", position: "absolute", top: "2px", left: "26px" }}>{getPermissionsDisplay(p)}</div>
              {isEditable(p) ?
              <IonPhotoViewer
                title={getDateFromPath(p.path)}
                src={p.url}
              >
                <IonLabel><IonIcon icon={cameraOutline} style={{ marginRight: "10px" }} />{getDateFromPath(p.path)}</IonLabel>
              </IonPhotoViewer>:<IonLabel><IonIcon icon={cameraOutline} style={{ marginRight: "10px" }} />{getDateFromPath(p.path)}</IonLabel>}
            </IonItem>
          </IonItemSliding>
        ))}
      </div>
      <IonLoading duration={0} isOpen={busy} />
      <IonFab vertical="bottom" horizontal="end" slot="fixed">
        {/*  */}
        <IonFabButton >
          <IonIcon icon={addOutline}></IonIcon>
        </IonFabButton>
        <IonFabList side="top">
          <IonFabButton onClick={() => { history.push("/app/clients/" + props.clientId + "/comment/0") }} key="0">
            <IonIcon icon={documentOutline} />
          </IonFabButton>

          <IonFabButton onClick={() => { takePhoto() }}>
            <IonIcon icon={cameraOutline}></IonIcon>
          </IonFabButton>

          {templates.map((t: any) => (
            <IonFabButton onClick={() => { history.push("/app/clients/" + props.clientId + "/comment/0/" + t.id) }} key={t.id}>
              <IonLabel>{t.topic.length > 4 ? t.topic.substring(0, 4) : t.topic}</IonLabel>
            </IonFabButton>
          ))}
        </IonFabList>
      </IonFab>
    </div>

  );
};

export default ClientCommentsList;





